import React from 'react';
import { SecureRoute } from 'components/shared/secure_route';
import { connect } from 'react-redux';
import { ViewMounter } from '../view_mounter';
import { Panel, PanelPresets, UserPermissionsIds } from '../../utility/enumerations';

function DashboardContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/dashboard"
        exact
        pathPermissionId={UserPermissionsIds.AccessDashboard}
        render={(props) => ViewMounter(props, {
          viewPath: 'dashboard/dashboard',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: true,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={false}
        component={undefined}
      />
      <SecureRoute
        path="/dashboard/admin/doc-assignment-dashboard"
        exact
        pathPermissionId={UserPermissionsIds.AccessDocumentAssignmentDashboard}
        render={(props) => ViewMounter(props, {
          viewPath: 'dashboard/admin/doc_assignment_dashboard',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: true,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={false}
        component={undefined}
      />
      <SecureRoute
        path="/dashboard/document-review-dashboard"
        pathPermissionId={UserPermissionsIds.AccessDocumentReviewDashboard}
        exact
        render={(props) => ViewMounter(props, {
          viewPath: 'dashboard/admin/document_review_dashboard',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: true,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={false}
        component={undefined}
      />
    </div>
  );
}

export default connect(null)(DashboardContainerScreen);
